"use client";

import type { HeaderNavbarProps } from "./types/header-navbar.types";

export const HeaderNavbar: React.FC<HeaderNavbarProps> = (props) => {
  const { children, ...rest } = props;
  return <div {...rest}>{children}</div>;
};

HeaderNavbar.displayName = "HeaderNavbar";
